import React from 'react';
import PropTypes from 'prop-types';
import {NavigationContainer} from '@react-navigation/native';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import MaintenanceModeScreen from '../../screens/maintenanceModeScreen';
import PrivacyPolicyScreen from '../../screens/privacyPolicyScreen';
import LegalInformationScreen from '../../screens/legalInformationScreen';
import {Routes} from '../../navigation/constants';
import translate from '../../services/localization';

const Stack = createNativeStackNavigator();

// Legal information remains accessible inside the blocking maintenance modal.
// This independent stack never changes the user's underlying navigation state.
export default function MaintenanceNavigator({infoText, infoURL}) {
  return (
    <NavigationContainer independent linking={{enabled: false, config: {screens: {
      [Routes.PRIVACY_POLICY]: 'privacy',
      [Routes.TERMS_CONDITIONS]: 'terms',
    }}}}>
      <Stack.Navigator>
        <Stack.Screen name={Routes.MAINTENANCE_MODE} options={{headerShown: false}}>
          {props => <MaintenanceModeScreen {...props} infoText={infoText} infoURL={infoURL} />}
        </Stack.Screen>
        <Stack.Screen name={Routes.PRIVACY_POLICY} component={PrivacyPolicyScreen}
          options={{title: translate('about').legal.title}} />
        <Stack.Screen name={Routes.TERMS_CONDITIONS} component={LegalInformationScreen}
          options={{title: translate('legalInformation').title}} />
      </Stack.Navigator>
    </NavigationContainer>
  );
}

MaintenanceNavigator.propTypes = {
  infoText: PropTypes.string,
  infoURL: PropTypes.string,
};
